<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { ParameterCardV2 } from '@Shelly/shelly-design-system/index';
	//Components
	import ThumbLayerChart from 'src/components/Chart/LayerChart/ThumbLayerChart.svelte';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { mapIconToThin } from 'src/helpers/new-layout-helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { ChartConfigInterface } from 'src/types/Chart';

	export let device: Device,
		deviceChartsConfig: ChartConfigInterface[],
		handleOnClickThumbChart: (e: CustomEvent | Event) => void,
		statuses = [];

	$: mainLabel = Array.isArray(statuses) ? statuses.find((i) => i.mainLabel) : undefined;
</script>

{#if mainLabel}
	{#if deviceChartsConfig.length}
		<ThumbLayerChart {device} on:click={handleOnClickThumbChart} />
	{/if}
	<ParameterCardV2
		icon={mapIconToThin(mainLabel.icon)}
		iconColor={mainLabel?.iconColor || ''}
		title={capFirstChar(mainLabel.value)}
		description={capFirstChar(
			$format(`title_chart_${mainLabel.peripheralType}`, {
				default: mainLabel.peripheralType,
			}) || '',
		)}
	/>
{/if}
